import { render, staticRenderFns } from "./ShowPack.vue?vue&type=template&id=9c50d8bc&scoped=true&"
import script from "./ShowPack.vue?vue&type=script&lang=js&"
export * from "./ShowPack.vue?vue&type=script&lang=js&"
import style0 from "./ShowPack.vue?vue&type=style&index=0&id=9c50d8bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c50d8bc",
  null
  
)

export default component.exports